import { render, staticRenderFns } from "./addImage.vue?vue&type=template&id=4c963702&scoped=true&lang=html&"
import script from "./addImage.vue?vue&type=script&lang=js&"
export * from "./addImage.vue?vue&type=script&lang=js&"
import style0 from "./addImage.vue?vue&type=style&index=0&id=4c963702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c963702",
  null
  
)

export default component.exports